import { render } from "./PhoneNumberForm.vue?vue&type=template&id=54310f60&scoped=true&ts=true"
import script from "./PhoneNumberForm.vue?vue&type=script&lang=ts"
export * from "./PhoneNumberForm.vue?vue&type=script&lang=ts"

import "./PhoneNumberForm.vue?vue&type=style&index=0&id=54310f60&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54310f60"]])

export default __exports__